
  export const style={
    inpuStyle:{
      colorInput:"#B3247C"
    },
    url:{
      urlClient:"https://ioasys.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.amazonaws.com/Logos/ioasys.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: false,
       autoRegister: false,
       recaptchaVersion : "V1"
    },
    CurrencyName:{
      name:"Noz/Nozes"
    },
    teamName:{
      name:"ioasys"
    },
    hasToken: true,
    hostHeader: "ioasys"
  }
